import ManageBilling from '../../../manageBilling/ManageBilling'
import { Elements } from '@stripe/react-stripe-js'
import NewCardModal from '../../../manageBilling/NewCardModal'
import UpdateCardModal from '../../../manageBilling/UpdateCardModal'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'

// Stripe Elements appearance — themes embedded card / address widgets to
// the GoPower brand so they match the surrounding modal.
const stripeOptions = {
    appearance: {
        theme: 'flat',
        variables: {
            colorPrimary: '#005339',
            colorBackground: '#FFFFFF',
            colorText: '#0B2926',
            colorTextSecondary: '#6B7673',
            colorDanger: '#B42222',
            fontFamily:
                "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
            fontSizeBase: '14px',
            borderRadius: '14px',
            spacingUnit: '4px',
        },
        rules: {
            '.Label': {
                fontSize: '13px',
                fontWeight: '400',
                color: '#6B7673',
                marginBottom: '6px',
            },
            '.Input': {
                backgroundColor: '#FFFFFF',
                border: '1px solid #EDEBE4',
                padding: '11px 14px',
                fontSize: '14px',
                color: '#0B2926',
                boxShadow: 'none',
            },
            '.Input:focus': {
                border: '1px solid #005339',
                boxShadow: 'none',
                outline: 'none',
            },
            '.Input--invalid': {
                border: '1px solid #B42222',
            },
            '.Error': {
                color: '#B42222',
                fontSize: '13px',
                marginTop: '6px',
            },
            '.Tab': {
                border: '1px solid #EDEBE4',
                backgroundColor: '#FFFFFF',
                padding: '11px 14px',
            },
            '.Tab--selected': {
                border: '1px solid #005339',
                backgroundColor: '#FFFFFF',
            },
        },
    },
}


function EditBilling({
    data,
    myProperty,
    isLoading,
    stripePromise,
    isRecurring,
    reloadWallet,
    setShowManageBilling,
    userWalletData,
}) {
    let { secondPathId } = useParams()

    const [openNewCardModal, setOpenNewCardModal] = useState(false)
    const [creditCardChanged, setCreditCardChanged] = useState(Date.now())
    const [cardInfoToEdit, setCardInfoToEdit] = useState({})
    const [openCardModal, setOpenCardModal] = useState(false)

    const handleNewCardModal = () => {
        setOpenNewCardModal(true)
    }

    const handleEditCardModal = (cardInfo) => {
        setOpenCardModal(true)
        setCardInfoToEdit(cardInfo)
    }

    return (
        <>
            <ManageBilling
                setShowManageBilling={setShowManageBilling}
                openModal={handleNewCardModal}
                openEditModal={handleEditCardModal}
                userWalletData={userWalletData}
                creditCardChanged={creditCardChanged}
                isRecurring={isRecurring}
                topUpAmount={data.userSettings.topUpAmount}
                nextBillDate={myProperty.billingModel?.nextBillDate}
                powerType={myProperty.powerType}
                myProperty={myProperty}
                loading={isLoading}
                secondPathId={secondPathId}
            />
            <Elements stripe={stripePromise} options={stripeOptions}>
                <NewCardModal
                    handleClose={() =>
                        setOpenNewCardModal(false)
                    }
                    open={openNewCardModal}
                    loading={isLoading}
                    reloadWallet={() => {
                        reloadWallet()
                        setCreditCardChanged(Date.now())
                    }}
                />
            </Elements>
            <Elements stripe={stripePromise} options={stripeOptions}>
                <UpdateCardModal
                    handleClose={() =>
                        setOpenCardModal(false)
                    }
                    open={openCardModal}
                    cardInfo={cardInfoToEdit}
                    reloadWallet={() => {
                        reloadWallet()
                        setCreditCardChanged(Date.now())
                    }}
                    loading={isLoading}
                />
            </Elements>
        </>
    )
}

export default EditBilling